import React, { createContext, useContext, useEffect, useSyncExternalStore } from 'react';
import { identity } from '../chronicles-ui/identity';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const state = useSyncExternalStore(identity.subscribe, identity.getSnapshot);
    useEffect(() => { identity.initialize(); }, []);
    return (
        <AuthContext.Provider value={{ ...state, token: identity.getToken(), setToken: identity.setToken, logout: identity.logout, refreshIdentity: identity.refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() { return useContext(AuthContext); }
